import { render, staticRenderFns } from "./VendorList.vue?vue&type=template&id=1abfe658&scoped=true"
import script from "./VendorList.vue?vue&type=script&lang=js"
export * from "./VendorList.vue?vue&type=script&lang=js"
import style0 from "./VendorList.vue?vue&type=style&index=0&id=1abfe658&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1abfe658",
  null
  
)

export default component.exports